export const Role = {
  Admin: "ROLE_ADMIN",
  Manager: "ROLE_MANAGER"
};
